import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Row,
  CardTitle,
} from "reactstrap";
import * as moment from "moment";
import BreadCrumb from "../../Components/Common/BreadCrumb";

//redux
import { useSelector, useDispatch } from "react-redux";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

//Import actions
import {
  getImports as onGetImports,
  updateRow as onUpdateRow,
  updateStatus as onUpdateStatus,
  getSuppliers as onGetSuppliers,
} from "../../slices/thunks";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import keepaImg from "../../assets/images/brands/keepa.png";
import { createSelector } from "reselect";

//AG GRID
import NumericEditor from "../../Components/Common/numericEditor";
import AsinRenderer from "../../Components/Common/AsinRendered.jsx";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry } from "ag-grid-community";
import {
  CellSelectionModule,
  AllEnterpriseModule,
  LicenseManager,
} from "ag-grid-enterprise";
import ColourCellRenderer from "../../Components/Common/colourCellRender.js";
import { productsStatus } from "../../Components/constants/layout";
import RejectModal from "../../Components/Common/RejectModal";
import StatusUpdateResultModal from "../../Components/Common/StatusUpdateResultModal";
import CustomInnerHeader from "../../Components/Common/CustomInnerHeader.jsx";

ModuleRegistry.registerModules([AllEnterpriseModule, CellSelectionModule]);
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-076901}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Cartzy}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{BCAT}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{BCAT}_need_to_be_licensed___{BCAT}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{11_February_2026}____[v3]_[01]_MTc3MDc2ODAwMDAwMA==4a557ef1e71d7e706797c31212266eae"
);

const InitialAnalysis = () => {
  const [gridApi, setGridApi] = useState(null);
  const [modal, setModal] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [updateResult, setUpdateResult] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedAnalysisStatus, setSelectedAnalysisStatus] = useState([
    { label: "Working", value: 5 },
  ]);
  const [selectedSalesChannels, setSelectedSalesChannels] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment());
  const [dateTo, setDateTo] = useState(moment());

  const analysisStatus = [
    {
      options: [
        { label: "Working", value: 5 },
        { label: "Rejected", value: 6 },
        { label: "Ready For Stock", value: 4 },
      ],
    },
  ];
  const salesChannels = [
    { label: "FBA", value: "FBA" },
    { label: "FBM", value: "FBM" },
    { label: "eBay", value: "eBay" },
    { label: "Walmart", value: "walmart" },
    { label: "Other", value: "other" },
    { label: "Online Store", value: "online" },
    { label: "LIQUIDATIONS", value: "liquidations" },
  ];

  const dispatch = useDispatch();

  const selectFilesData = createSelector(
    (state) => state.Analysis,
    (imports) => imports,
    (updatedStatus) => updatedStatus,
    (updatedRow) => updatedRow,
    (error) => error
  );
  const selectSuppliersData = createSelector(
    (state) => state.Suppliers.suppliers,
    (suppliers) => suppliers
  );

  const suppliers = useSelector(selectSuppliersData);
  const { imports, updatedStatus, updatingStatus, error } = useSelector(selectFilesData);

  const [rowData, setRowData] = useState([]);
  const rowSelection = {
    mode: "multiRow",
    headerCheckbox: true,
  };

  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      suppressHeaderMenuButton: true,
      headerComponentParams: {
        innerHeaderComponent: CustomInnerHeader,
      },
    };
  }, []);

  const saveNewValue = (params) => {
    return false;
  };

  const getSelectedSalesChannels = () => {
    let salesChannel = 0;

    selectedSalesChannels.forEach((item) => {
      switch (item.value) {
        case "FBA":
          salesChannel += 1;
          break;
        case "FBM":
          salesChannel += 2;
          break;
        case "eBay":
          salesChannel += 4;
          break;
        case "walmart":
          salesChannel += 8;
          break;
        case "other":
          salesChannel += 16;
          break;
        case "online":
          salesChannel += 32;
          break;
        case "liquidations":
          salesChannel += 64;
          break;
        default:
          break;
      }
    });
    return salesChannel;
  };

  const getImports = () => {
    const status = selectedAnalysisStatus.map((item) => item.value);
    if (status.indexOf(6) > -1) {
      status.push(7);
      status.push(8);
    }
    dispatch(
      onGetImports({
        status: status.length > 0 ? status : null,
        sup_id: supplier.length > 0 ? supplier.map((item) => item.value) : null,
        date_from: moment(dateFrom).format("YYYY-MM-DD"),
        date_to: moment(dateTo).format("YYYY-MM-DD"),
        current_status: productsStatus.STATUS_IMPORTED,
        salesChannel:
          getSelectedSalesChannels() == 0 ? null : getSelectedSalesChannels(),
      })
    );
  };

  const getSuppliers = () => {
    if (!suppliers || suppliers.length === 0) {
      const data = {
        page: 0,
        total_rows: 1000,
        sort_by: "sup_name",
      };
      dispatch(onGetSuppliers(data));
    }
  };

  const getShipToWarehouse = (data) => {
    return data.imp_packageWeight > 0 && data.imp_packageWeight <= 8
      ? 1.5
      : data.imp_packageWeight > 8 && data.imp_packageWeight <= 16
      ? 3.1
      : data.imp_packageWeight > 16 && data.imp_packageWeight <= 24
      ? 4.65
      : data.imp_packageWeight > 24 && data.imp_packageWeight <= 32
      ? 6.2
      : 0;
  };

  const getShipToAmazon = (data) => {
    return data.imp_FBA &&
      data.imp_fulfillmentSubtotal < 10 &&
      data.imp_fulfillmentSubtotal > 0
      ? 2
      : data.imp_FBA &&
        data.imp_fulfillmentSubtotal >= 10 &&
        data.imp_fulfillmentSubtotal < 20
      ? 3
      : data.imp_FBA &&
        data.imp_fulfillmentSubtotal >= 20 &&
        data.imp_fulfillmentSubtotal < 30
      ? 4
      : data.imp_FBA &&
        data.imp_fulfillmentSubtotal >= 30 &&
        data.imp_fulfillmentSubtotal < 40
      ? 5
      : data.imp_FBA &&
        data.imp_fulfillmentSubtotal >= 40 &&
        data.imp_fulfillmentSubtotal < 50
      ? 6
      : data.imp_FBA && data.imp_fulfillmentSubtotal >= 50
      ? 8
      : 0;
  };

  const getShipToCustomer = (data) => {
    return data.imp_FBM &&
      data.imp_packageWeight > 0 &&
      data.imp_packageWeight <= 1
      ? 5.96
      : data.imp_FBM &&
        data.imp_packageWeight > 1 &&
        data.imp_packageWeight <= 2
      ? 7.64
      : data.imp_FBM &&
        data.imp_packageWeight > 2 &&
        data.imp_packageWeight <= 3
      ? 8.86
      : data.imp_FBM &&
        data.imp_packageWeight > 3 &&
        data.imp_packageWeight <= 4
      ? 9.69
      : data.imp_FBM &&
        data.imp_packageWeight > 4 &&
        data.imp_packageWeight <= 5
      ? 10.13
      : data.imp_FBM &&
        data.imp_packageWeight > 5 &&
        data.imp_packageWeight <= 6
      ? 10.34
      : data.imp_FBM &&
        data.imp_packageWeight > 6 &&
        data.imp_packageWeight <= 7
      ? 10.64
      : data.imp_FBM &&
        data.imp_packageWeight > 7 &&
        data.imp_packageWeight <= 8
      ? 10.69
      : data.imp_FBM &&
        data.imp_packageWeight > 8 &&
        data.imp_packageWeight <= 9
      ? 10.78
      : data.imp_FBM &&
        data.imp_packageWeight > 9 &&
        data.imp_packageWeight <= 10
      ? 11.74
      : data.imp_FBM &&
        data.imp_packageWeight > 10 &&
        data.imp_packageWeight <= 21
      ? 11.79
      : 0;
  };
  const keepaLinkRenderer = (params) => {
    return (
      <center>
        <a href={params.data.imp_keepaLink} target="_blank">
          <img alt={`keepa link logo`} src={keepaImg} className="logo" />
        </a>
      </center>
    );
  };

  const cellNetProfitRules = {
    "cell-netProfit-fail": (params) => params.value < 2,
    "cell-netProfit-success": (params) => params.value >= 2,
  };

  const cellSellingPriceRules = {
    "cell-sellingPrice-fail": (params) => params.value < 0,
    "cell-sellingPrice-success": (params) => params.value >= 0,
  };

  const getPackCost = (data) => {
    return data.imp_packQuantity * data.imp_vendorCost;
  };

  const getProfit = (data) => {
    return (
      data.imp_sellPrice -
      (data.imp_referralFee +
        data.imp_InboundPlac +
        data.imp_fulfillmentSubtotal +
        getPackCost(data))
    );
  };

  const getRoi = (data) => {
    const packCost = getPackCost(data);
    const profit = getProfit(data);
    const roi = profit != 0 && packCost != 0 ? profit / packCost : 0;
    return roi != 0 ? roi * 100 : 0;
  };
  const getStripeSurcharge = (data) => {
    return data.imp_packQuantity * data.imp_vendorCost * 0.035;
  };
  const getNetProfit = (data) => {
    const profit = getProfit(data);
    const rest =
      getStripeSurcharge(data) +
      getShipToWarehouse(data) +
      getShipToAmazon(data) +
      getShipToCustomer(data) +
      data.imp_FBAFBMPrep;

    return profit != 0 ? profit - rest : 0;
  };

  const getSellingPriceVariation = (data) => {
    return data.imp_currentPrimeSellPrice == null
      ? 0
      : data.imp_currentPrimeSellPrice - data.imp_sellPrice;
  };

  // Column Definitions: Defines the columns to be displayed.
  const [colDefs, setColDefs] = useState([
    {
      headerName: "ASIN",
      field: "imp_ASIN",
      pinned: "left",
      filter: false,
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
      cellRenderer: AsinRenderer,
      cellClass: "age-border",
    },
    {
      headerName: "Sales Channel",
      field: "imp_salesChannel",
      pinned: "left",
      filter: false,
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
    },
    {
      headerName: "Product ID",
      field: "imp_productID",
      pinned: "left",
      suppressMovable: true,
      headerStyle: { "background-color": "#90EE90" },
    },
    {
      headerName: "UPC",
      field: "imp_UPC",
      headerStyle: { "background-color": "#90EE90" },
      headerComponentParams: { icon: "fa-cog" },
      cellClass: "age-border",
      valueSetter: saveNewValue,
      editable: true,
    },
    {
      headerName: "Title",
      field: "imp_title",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: (params) =>
        params?.data?.imp_salesChannel &&
        ["liquidations", "ebay"].includes(
          params.data.imp_salesChannel.toString().toLowerCase()
        ),
      valueSetter: saveNewValue,
    },
    {
      headerName: "Keepa Link",
      field: "imp_KeepaLink",
      headerStyle: { "background-color": "#90EE90" },
      cellRenderer: keepaLinkRenderer,
      cellClass: "age-border",
    },
    {
      headerName: "Last Run",
      field: "imp_lastModifiedDate",
      headerStyle: { "background-color": "#90EE90" },
      cellRenderer: (params) => {
        return moment(params.value).format("MM/DD/YYYY hh:mm A");
      },
      cellClass: "age-border",
    },
    {
      headerName: "Brand",
      field: "imp_brand",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Vendor",
      field: "imp_ven_name",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Pack Qty. (check title)",
      field: "imp_packQuantity",
      editable: true,
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },
    {
      headerName: "Vendor Cost",
      field: "imp_vendorCost",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },
    {
      headerName: "Sales Rank",
      field: "imp_salesRank",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "New FBA Offers",
      field: "imp_newFBAOffers",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "New FBM Offers",
      field: "imp_newFBMOffers",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Est Sales",
      field: "imp_estimatedSales",
      editable: (params) =>
        params?.data?.imp_salesChannel &&
        ["liquidations", "ebay"].includes(
          params.data.imp_salesChannel.toString().toLowerCase()
        ),
      cellEditor: NumericEditor,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Avg Sales Rank 90d",
      field: "imp_avgSalesRank90Days",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Bought In Past Month",
      field: "imp_boughtInPastMonth",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Pack Cost",
      field: "imp_packCost",
      headerTooltip: "Pack Qty * Vendor Cost",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      cellClass: "age-border",
      headerStyle: { "background-color": "#90EE90" },
      /*valueGetter: (params) => {
        return getPackCost(params.data);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "ROI",
      field: "imp_ROI",
      editable: false,
      headerTooltip: "If(profit not equal to 0(zero)) profit / pack cost",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      /* valueGetter: (params) => {
        return getRoi(params.data);
      },*/
      valueFormatter: (params) =>
        params.value ? params.value.toFixed(2) + " %" : "0 %",
    },

    {
      headerName: "Stripe Surcharge (3.5%)",
      field: "imp_stripeSurcharge",
      /*valueGetter: (params) => {
        return getStripeSurcharge(params.data);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      headerTooltip: "Pack Cost * 0.035",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
    },

    {
      headerName: "Ship To Warehouse",
      field: "imp_shipToWarehouse",
      headerTooltip:
        "IF(AND(Package Weight>0, Package Weight<=8), 1.5, IF(AND(Package Weight>8, Package Weight<=16), 3.1, IF(AND(Package Weight>16, Package Weight<=24), 4.65, IF(AND(Package Weight>24, Package Weight<=32), 6.2, 0))))",
      /*valueGetter: (params) => {
        return getShipToWarehouse(params.data);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      editable: true,
      valueSetter: saveNewValue,
    },
    {
      headerName: "Ship To Amazon",
      field: "imp_shipToAmazon",
      headerTooltip:
        "IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal < 10, Fullfilment Subtotal > 0), 2, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 10, Fullfilment Subtotal < 20), 3, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 20, Fullfilment Subtotal < 30), 4, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 30, Fullfilment Subtotal < 40), 5, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 40, Fullfilment Subtotal < 50), 6, IF(AND(FBA/FBM = 'FBA', Fullfilment Subtotal >= 50), 8, 0))))))",
      /*valueGetter: (params) => {
        return getShipToAmazon(params.data);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Ship To Customer",
      field: "imp_shipToCustomer",
      headerTooltip:
        "IF(AND(FBA/FBM='FBM',imp_packageWeight>0,imp_packageWeight<=1),5.96, IF(AND(FBA/FBM='FBM',imp_packageWeight>1,imp_packageWeight<=2),7.64, IF(AND(FBA/FBM='FBM',imp_packageWeight>2,imp_packageWeight<=3),8.86, IF(AND(FBA/FBM='FBM',imp_packageWeight>3,imp_packageWeight<=4),9.69, IF(AND(FBA/FBM='FBM',imp_packageWeight>4,imp_packageWeight<=5),10.13, IF(AND(FBA/FBM='FBM',imp_packageWeight>5,imp_packageWeight<=6),10.34, IF(AND(FBA/FBM='FBM',imp_packageWeight>6,imp_packageWeight<=7),10.64, IF(AND(FBA/FBM='FBM',imp_packageWeight>7,imp_packageWeight<=8),10.69, IF(AND(FBA/FBM='FBM',imp_packageWeight>8,imp_packageWeight<=9),10.78, IF(AND(FBA/FBM='FBM',imp_packageWeight>9,imp_packageWeight<=10),11.74, IF(AND(FBA/FBM='FBM',imp_packageWeight>10,imp_packageWeight<=21),11.79,0)))))))))))",
      /*valueGetter: (params) => {
        return getShipToCustomer(params.data);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "FBA/FBM Prep.",
      field: "imp_FBAFBMPrep",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },
    {
      headerName: "Net Profit",
      field: "imp_netProfit",
      headerTooltip:
        "If(profit not equal to 0(zero)){ profit - stripe surcharge + ship to warehouse + ship to amazon + ship to customer + fba/fbm prep)} else ''",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      cellClassRules: cellNetProfitRules,
      /*valueGetter: (params) => {
        return getNetProfit(params.data);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "At Sell Price",
      field: "imp_ATSellPrice",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      valueSetter: saveNewValue,
      editable: (params) =>
        params.data.imp_salesChannel === "eBay" ||
        params.data.imp_salesChannel === "walmart" ||
        params.data.imp_salesChannel === "Walmart" ||
        params.data.imp_salesChannel === "any" ||
        params.data.imp_salesChannel === "LIQUIDATIONS" ||
        params.data.imp_salesChannel === "liquidations" ||
        params.data.imp_salesChannel === "other",
    },
    {
      headerName: "Net Profit Margin",
      field: "imp_netProfitMargin",
      headerStyle: { "background-color": "#90EE90" },
      valueFormatter: (params) => params.value.toFixed(2) + "%",
    },
    {
      headerName: "Enter Current Prime Sell Price",
      field: "imp_currentPrimeSellPrice",
      editable: true,
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "AVG eBay Price",
      field: "imp_currentEbaySellPrice",
      editable: true,
      cellEditor: "agNumberCellEditor",
      valueSetter: saveNewValue,
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },

    {
      headerName: "Selling Price +/-",
      field: "imp_sellingPriceVariation",
      headerTooltip: "Enter Current Prime Sell Price - AT Sell Price",
      headerComponentParams: {
        icon: "mdi-information-slab-circle",
      },
      cellClassRules: cellSellingPriceRules,
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      /*valueGetter: (params) => {
        return getSellingPriceVariation(params.data);
      },*/
      valueFormatter: (params) => currencyFormatter(params.value, "$"),
    },
    {
      headerName: "90 Day AMZ BuyBox Avg",
      field: "imp_90DaysAvgBuyBox",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Approval To List Code",
      field: "imp_approvalToListCode",
      editable: true,
      minWidth: 180,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
      cellEditor: "agRichSelectCellEditor",
      cellRenderer: ColourCellRenderer,
      cellEditorParams: {
        cellRenderer: ColourCellRenderer,
        values: [
          "1-Open To List",
          "2-Click and Approved",
          "3-Brand Application",
          "4-Invoice Required",
          "5-eBay",
          "6-walmart",
          "7-Other",
          "99-Do Not List",
        ],
      },
      valueGetter: (params) => {
        switch (params.data.imp_approvalToListCode) {
          case 1:
            return "1-Open To List";
          case 2:
            return "2-Click and Approved";
          case 3:
            return "3-Brand Application";
          case 4:
            return "4-Invoice Required";
          case 5:
            return "5-eBay";
          case 6:
            return "6-walmart";
          case 7:
            return "7-Other";
          case 99:
            return "99-Do Not List";
          default:
            return "";
        }
      },
    },
    {
      headerName: "Package Dimensions (max. L >= 25ins)",
      field: "imp_packageDimensions",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Package Weight (max. 20lbs)",
      field: "imp_packageWeight",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
      valueFormatter: (params) => (params.value ? params.value.toFixed(2) : 0),
    },
    {
      headerName: "Variants",
      field: "imp_variants",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Reviews",
      field: "imp_reviews",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Product Rating",
      field: "imp_productRating",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
    {
      headerName: "Does Amazon Sell",
      field: "imp_amazonSeller",
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#A4C2F4" },
      cellClass: "age-border",
    },
    {
      headerName: "Analysis notes",
      field: "imp_notes",
      editable: true,
      valueSetter: saveNewValue,
      headerStyle: { "background-color": "#FFF" },
      cellClass: "age-border",
    },
    {
      headerName: "Rejection Reason",
      field: "imp_rejectionReason",
      headerStyle: { "background-color": "#90EE90" },
      cellClass: "age-border",
    },
  ]);

  const currencyFormatter = (currency) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(currency);
  };

  useEffect(() => {
    setRowData(imports);
  }, [imports]);

  useEffect(() => {
    if (suppliers) {
      setSuppliersList(
        suppliers.map((item) => ({ label: item.sup_name, value: item.sup_id }))
      );
    }
  }, [suppliers]);

  useEffect(() => {
    if (updatedStatus) {
      getImports();
    }
  }, [updatedStatus]);

  useEffect(() => {
    getImports();
    getSuppliers();
  }, []);

  const autoSizeStrategy = useMemo(() => {
    return {
      type: "fitGridWidth",
      defaultMinWidth: 100,
      widthBetweenCols: 10,
    };
  }, []);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
      setDate(defaultdate());
    }
  }, [modal]);

  const defaultdate = () => {
    let d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    let h = d.getHours() % 12 || 12;
    let ampm = d.getHours() < 12 ? "AM" : "PM";
    return (
      d.getDate() +
      " " +
      months[d.getMonth()] +
      ", " +
      d.getFullYear() +
      ", " +
      h +
      ":" +
      d.getMinutes() +
      " " +
      ampm
    ).toString();
  };

  const [date, setDate] = useState(defaultdate());

  const dateformate = (e) => {
    const dateString = e.toString().split(" ");

    let time = dateString[4];
    let H = +time.substr(0, 2);
    let h = H % 12 || 12;
    h = h <= 9 ? (h = "0" + h) : h;
    let ampm = H < 12 ? "AM" : "PM";
    time = h + time.substr(2, 3) + " " + ampm;

    const date = dateString[2] + " " + dateString[1] + ", " + dateString[3];
    const orderDate = (date + ", " + time).toString();
    setDate(orderDate);
  };

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  function handleAnalysisStatus(status) {
    setSelectedAnalysisStatus(status);
  }

  const onCellEditingStopped = (event) => {
    const row = event.data;
    let newRow;
    // Avoid unnecessary updates when value didn't change
    if (event.newValue === event.oldValue) {
      return false;
    }
    switch (event.column.colId) {
      case "imp_UPC":
        newRow = { ...row, imp_UPC: event.newValue };
        break;
      case "imp_currentPrimeSellPrice":
        newRow = {
          ...row,
          imp_currentPrimeSellPrice: event.newValue,
        };
        break;
      case "imp_approvalToListCode":
        let code;
        switch (event.newValue) {
          case "1-Open To List":
            code = 1;
            break;
          case "2-Click and Approved":
            code = 2;
            break;
          case "3-Brand Application":
            code = 3;
            break;
          case "4-Invoice Required":
            code = 4;
            break;
          case "5-eBay":
            code = 5;
            break;
          case "6-walmart":
            code = 6;
            break;
          case "7-Other":
            code = 7;
            break;
          case "99-Do Not List":
            code = 99;
            break;
          default:
            code = 0;
        }
        newRow = { ...row, imp_approvalToListCode: code };
        break;
      case "imp_notes":
        newRow = { ...row, imp_notes: event.newValue };
        break;
      case "imp_packQuantity":
        newRow = {
          ...row,
          imp_packQuantity: event.newValue,
          imp_packCost: event.newValue * row.imp_vendorCost,
        };
        break;
      case "imp_vendorCost":
        newRow = {
          ...row,
          imp_vendorCost: event.newValue,
        };
        break;
      case "imp_amazonSeller":
        newRow = {
          ...row,
          imp_amazonSeller: event.newValue,
        };
        break;
      case "imp_FBAFBMPrep":
        newRow = {
          ...row,
          imp_FBAFBMPrep: event.newValue,
        };
        break;
      case "imp_currentEbaySellPrice":
        newRow = {
          ...row,
          imp_currentEbaySellPrice: event.newValue,
        };
        break;
      case "imp_ATSellPrice":
        newRow = {
          ...row,
          imp_ATSellPrice: event.newValue,
        };
        break;
      case "imp_shipToWarehouse":
        newRow = { ...row, imp_shipToWarehouse: event.newValue };
        break;
      case "imp_estimatedSales": {
        const next = Number.parseInt(event.newValue, 10) || 0;
        if (next === row.imp_estimatedSales) return false;
        newRow = { ...row, imp_estimatedSales: next };
        break;
      }
      case "imp_title":
        newRow = { ...row, imp_title: event.newValue };
        break;
      default:
        newRow = { ...row };
    }
    dispatch(onUpdateRow(JSON.stringify(newRow)));
    const newData = [...rowData];
    const index = newData.findIndex((item) => item.imp_id === newRow.imp_id);
    newData[index] = newRow;
    setRowData(newData);
    return false;
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const onSelectionChanged = () => {
    const selectedData = gridApi.getSelectedRows();
    setSelectedRows(selectedData);
  };

  const handleUpdateStatus = async (statusData) => {
    try {
      const resultAction = await dispatch(onUpdateStatus(statusData));
      if (resultAction.payload?.success) {
        const result = resultAction.payload.data;
        
        // Show appropriate toast based on status
        if (result.status === "Success") {
          toast.success(result.summaryMessage || "Status updated successfully", {
            position: "top-center",
            autoClose: 2000,
          });
        } else if (result.status === "Parcial") {
          toast.warning(result.summaryMessage || "Status updated with some errors", {
            position: "top-center",
            autoClose: 3000,
          });
        } else if (result.status === "Failed") {
          toast.error(result.summaryMessage || "Failed to update status", {
            position: "top-center",
            autoClose: 3000,
          });
        }
        
        // Show detailed modal only for partial success or failures
        if (result.status === "Parcial" || result.status === "Failed") {
          setUpdateResult(result);
          setResultModal(true);
        }
      }
    } catch (error) {
      console.error("Update status error:", error);
    }
  };

  const handleRejectProduct = (reason) => {
    handleUpdateStatus({
      imp_ids: selectedRows.map((item) => item.imp_id),
      imp_status: productsStatus.STATUS_REJECTED_INITIAL,
      imp_rejectionReason: reason,
    });
    setModal(false);
  };

  document.title = "Initial Analysis | Buyers Club";
  return (
    <div className="page-content">
      <RejectModal
        show={modal}
        type="initial"
        onRejectClick={(reason) => handleRejectProduct(reason)}
        onCloseClick={() => setModal(false)}
      />
      <StatusUpdateResultModal
        show={resultModal}
        result={updateResult}
        onCloseClick={() => {
          setResultModal(false);
          setUpdateResult(null);
        }}
      />
      <Container fluid>
        <BreadCrumb title="Initial Analysis" pageTitle="Analysis" />
        <Row>
          <Col lg={12}>
            <Card id="refreshesList">
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Initial Analysis</h5>
                  </div>
                </Row>
              </CardHeader>

              <CardBody className="pt-0">
                <Card className=" p-2">
                  <CardTitle className="mb-2">
                    <h5 className="card-title mb-0">Filters</h5>
                  </CardTitle>
                  <Row className="mb-2">
                    <Col xs={12} sm={12} xl={3} className="d-flex gap-3 mb-2">
                      <div>
                        <label htmlFor="analysisDate" className="form-label">
                          Date From
                        </label>
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          placeholder="Select a date from"
                          onChange={(selectedDates, dateStr, instance) => {
                            setDateFrom(selectedDates[0]);
                          }}
                          options={{
                            defaultDate: moment(dateFrom).format("MM-DD-YYYY"),
                            mode: "single",
                            dateFormat: "m-d-Y",
                          }}
                        />
                      </div>

                      <div>
                        <label htmlFor="analysisDate" className="form-label">
                          Date To
                        </label>
                        <Flatpickr
                          className="form-control"
                          id="datepicker-publish-input"
                          label="To"
                          placeholder="Select a date to"
                          onChange={(selectedDates, dateStr, instance) => {
                            setDateTo(selectedDates[0]);
                          }}
                          options={{
                            defaultDate: moment(dateTo).format("MM-DD-YYYY"),
                            mode: "single",
                            dateFormat: "m-d-Y",
                          }}
                        />
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                      <label htmlFor="analysisStatus" className="form-label">
                        Analysis Status
                      </label>
                      <Select
                        autoFocus
                        label="Select Analysis Status"
                        placeholder="Select Status"
                        value={selectedAnalysisStatus}
                        onChange={(e) => {
                          handleAnalysisStatus(e);
                        }}
                        options={analysisStatus}
                        isMulti
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                      <label htmlFor="supplier" className="form-label">
                        Supplier
                      </label>
                      <Select
                        placeholder="Select Supplier"
                        value={supplier}
                        onChange={(e) => {
                          setSupplier(e);
                        }}
                        options={suppliersList}
                        isMulti
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={3}>
                      <label htmlFor="salesChannel" className="form-label">
                        Sales Channel
                      </label>
                      <Select
                        placeholder="Select Sales Channel"
                        id="salesChannel"
                        value={selectedSalesChannels}
                        onChange={(e) => {
                          setSelectedSalesChannels(e);
                        }}
                        options={salesChannels}
                        isMulti
                      />
                    </Col>

                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div>
                        <button
                          type="button"
                          className="btn btn-primary  mt-2"
                          onClick={() => getImports()}
                        >
                          {" "}
                          <i className="ri-equalizer-fill me-1 align-bottom"></i>
                          Filter
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Card>
                <div className="d-flex gap-1 m-2">
                  <div className="d-flex gap-1 align-items-center">
                    <h4 className="text-muted">Total</h4>
                    <h4 className="text-muted">:</h4>
                    <h4 className="text-muted">{imports.length}</h4>
                    <h4 className="text-muted">|</h4>
                    <h4 className="text-muted">Selected</h4>
                    <h4 className="text-muted">:</h4>
                    <h4 className="text-muted">
                      {selectedRows.length > 0 ? selectedRows.length : 0}
                    </h4>
                  </div>
                  <div
                    className="d-flex gap-1 justify-content-end"
                    style={{ width: "100%" }}
                  >
                    <button
                      disabled={
                        updatingStatus ||
                        selectedRows.length === 0 ||
                        selectedRows.filter(
                          (item) =>
                            item.imp_status === productsStatus.STATUS_IMPORTED
                        ).length === 0
                      }
                      type="button"
                      className="btn btn-info"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_READYFORSTOCK,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      Ready for Stock
                    </button>
                    <button
                      disabled={
                        updatingStatus ||
                        selectedRows.length === 0 ||
                        selectedRows.filter(
                          (item) =>
                            item.imp_status ===
                            productsStatus.STATUS_READYFORSTOCK
                        ).length === 0
                      }
                      type="button"
                      className="btn btn-danger"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_IMPORTED,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      Back to Initial Analysis
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-warning"
                      onClick={() =>
                        selectedRows.length > 0
                          ? setModal(true)
                          : toast.error(
                              "Please choose at least one product to proceed"
                            )
                      }
                    >
                      <i className="ri-prohibited-line"></i>
                      Reject Product
                    </button>
                    <button
                      disabled={updatingStatus || selectedRows.length === 0}
                      type="button"
                      className="btn btn-success"
                      onClick={() =>
                        selectedRows.length > 0
                          ? handleUpdateStatus({
                              imp_ids: selectedRows.map(
                                (item) => item.imp_id
                              ),
                              imp_status: productsStatus.STATUS_READYFORSTOCK,
                            })
                          : toast.error("Please select a product")
                      }
                    >
                      {updatingStatus && <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>}
                      <i className="ri-check-line"></i>
                      Un-Reject Product
                    </button>
                  </div>
                </div>
                <div style={{ height: "70vh", width: "100%" }}>
                  <AgGridReact
                    onGridReady={onGridReady}
                    rowData={rowData}
                    defaultColDef={defaultColDef}
                    columnDefs={colDefs}
                    rowSelection={rowSelection}
                    maintainColumnOrder={true}
                    onCellEditingStopped={onCellEditingStopped}
                    suppressScrollOnNewData={true}
                    onSelectionChanged={onSelectionChanged}
                    cellSelection={true}
                    selectionColumnDef={{
                      pinned: "left",
                    }}
                    autoSizeStrategy={autoSizeStrategy}
                    overlayNoRowsTemplate={"No products found."}
                    getRowStyle={(params) => {
                      if (params.data.imp_approvalToListCode === 99) {
                        return { background: "#f4cccc" };
                      } else {
                        const packCost =
                          params.data.imp_packQuantity *
                          params.data.imp_vendorCost;
                        const profit =
                          params.data.imp_sellPrice -
                          (params.data.imp_referralFee +
                            params.data.imp_InboundPlac +
                            params.data.imp_fulfillmentSubtotal +
                            packCost);

                        const stripeSurcharge =
                          params.data.imp_packQuantity *
                          params.data.imp_vendorCost *
                          0.035;

                        const rest =
                          stripeSurcharge +
                          getShipToWarehouse(params) +
                          getShipToAmazon(params) +
                          getShipToCustomer(params) +
                          params.data.imp_FBAFBMPrep;

                        const netProfit = profit != 0 ? profit - rest : 0;

                        if (netProfit < 2) {
                          return { background: "#f4cccc" };
                        }

                        if (
                          params.data.imp_currentPrimeSellPrice > 0 &&
                          netProfit +
                            (params.data.imp_currentPrimeSellPrice -
                              params.data.imp_sellPrice) <
                            2
                        ) {
                          return { background: "#f4cccc" };
                        }
                      }
                    }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default InitialAnalysis;
